import Service from "./service.abstract";

export default class SerpDynamicService extends Service {
  constructor(url: string) {
    super();

    this.url = url;
    this.displayDefaultError = false;
    this.errorTopic = "service.error.serpDynamic";
  }
}
